import React, { useState } from "react";
import logo from "../../assets/GalaxcityLogo.png";
import darklogo from "../../assets/marshall/Galaxcitylogo7.png";
import mobileTabletLogo from "../../assets/GalaxcityLogo.png";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import gsap from "gsap";
import { useRef, useEffect } from "react";
import { Box } from "@mui/material";

// hambur

import Hambur from "../Hambur/Hambur";

function Nav({ theme = "light", forcedActiveSection = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isMarshallPage = location.pathname === "/marshall";
  const [isMobileTablet, setIsMobileTablet] = useState(window.innerWidth <= 1024);

  const themes = {
    dark: {
      bgColor: "rgba(0, 0, 0, 0.1)",
      textcolor: "white",
      navLogo: darklogo,
      mobileTabletLogo: mobileTabletLogo,
    },

    light: {
      bgColor: "rgba(255, 255, 255, 0.95)",
      textcolor: "rgba(0, 0, 0, 0.8)",
      navLogo: logo,
      mobileTabletLogo: mobileTabletLogo,
    },
  };

  const currentTheme = themes[theme] || themes.light;
  const displayLogo = isMobileTablet ? currentTheme.mobileTabletLogo : currentTheme.navLogo;

  // Animation Code here
  var logoRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      logoRef.current,
      {
        y: -20,
        opacity: 0,
      },
      { 
        y: 0, 
        opacity: 1, 
        duration: 0.8,
        ease: "power2.out"
      }
    );
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileTablet(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navlist = [
    { name: "Home", path: "/", dropdown: [] },
    { name: "Apple", path: "/applestore", dropdown: [] },
    { name: "Samsung", path: "/samsungStore", dropdown: [] },
    { name: "OnePlus", path: "/oneplusstore", dropdown: [] },
    { name: "Accessories", path: "/accessories", dropdown: [] },
  ];

  const [activeDrop, setActiveDrop] = useState(null);
  const hasForcedActive =
    forcedActiveSection === "apple" || forcedActiveSection === "samsung";

  return (
    <div
      className="nav-bar glass-nav"
      style={{
        background: theme === 'dark' ? 'rgba(0, 0, 0, 0.9)' : currentTheme.bgColor,
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.18)',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
      }}
    >      <NavLink
        to="/"
        ref={logoRef}
        className="logo"
        style={{ opacity: 0 }}
        onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
      >
        <img src={displayLogo} alt="galaxcity logo" style={{ borderRadius: '12px' }} />
      </NavLink>
      <div className="hamburCom">
        <Hambur theme={theme} />
      </div>
      <nav
        className="nav-menu"
        style={{
          background: 'rgba(255, 255, 255, 0.15)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          border: '1px solid rgba(0, 0, 0, 0.15)',
          borderRadius: '24px',
        }}
      >
        <ul className="ul">
          {navlist.map((navlist, index) => {
            const isForcedActive =
              (forcedActiveSection === "apple" && navlist.name === "Apple") ||
              (forcedActiveSection === "samsung" && navlist.name === "Samsung");
            return (
              <li
                key={index}
                style={{
                  listStyle: index === 0 ? "none" : "disc",
                  color: currentTheme.textcolor,
                  position: "relative",
                }}
                onMouseEnter={() => setActiveDrop(index)}
                onMouseLeave={() => setActiveDrop(null)}
              >
                <Box
                  component={NavLink}
                  to={navlist.path}
                  className="nav-items"
                  onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
                  sx={{
                    color: isForcedActive
                      ? 'rgba(74, 144, 226, 1)'
                      : currentTheme.textcolor,
                    fontWeight: 500,
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    "&.active": {
                      color: hasForcedActive
                        ? (isForcedActive
                            ? 'rgba(74, 144, 226, 1)'
                            : currentTheme.textcolor)
                        : 'rgba(74, 144, 226, 1)',
                    },
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      height: "2px",
                      background: 'linear-gradient(135deg, rgba(74, 144, 226, 0.8), rgba(143, 148, 251, 0.8))',
                      transform: isForcedActive ? "scaleX(1)" : "scaleX(0)",
                      transformOrigin: "bottom left",
                      transition: "transform 0.3s ease",
                      borderRadius: '2px',
                    },
                    "&.active::after": {
                      transform: hasForcedActive
                        ? (isForcedActive ? "scaleX(1)" : "scaleX(0)")
                        : "scaleX(1)",
                    },
                    "&:hover": {
                      color: 'rgba(74, 144, 226, 1)',
                    },
                    "&:hover::after": {
                      transform: "scaleX(1)",
                    },
                  }}
                >
                  {navlist.name}
                </Box>

                {/* Drop Down */}
                {navlist.dropdown.length > 0 && activeDrop === index && (
                  <div
                    style={{
                      backgroundColor: "transparent",
                      padding: "16px 0 0 0",
                      position: "absolute",
                      top: "25px",
                    }}
                  >
                    <div
                      className="dropdown-inner glass-card"
                      style={{
                        background: isMarshallPage ? 'rgba(0, 0, 0, 0.95)' : 'rgba(255, 255, 255, 0.95)',
                        backdropFilter: 'blur(16px)',
                        WebkitBackdropFilter: 'blur(16px)',
                        border: isMarshallPage ? '1px solid rgba(255, 255, 255, 0.18)' : '1px solid rgba(255, 255, 255, 0.18)',
                        borderRadius: '16px',
                        padding: '1rem',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                      }}
                    >
                      {navlist.dropdown.map((drop, dropIndex) => (
                        <Box
                          key={dropIndex}
                          component={NavLink}
                          to={drop.path}
                          className="nav-items"
                          sx={{
                            color: isMarshallPage ? 'white' : currentTheme.textcolor,
                            fontWeight: 500,
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            "&::after": {
                              content: '""',
                              position: "absolute",
                              bottom: 0,
                              left: 0,
                              width: "100%",
                              height: "2px",
                              background: 'linear-gradient(135deg, rgba(74, 144, 226, 0.8), rgba(143, 148, 251, 0.8))',
                              transform: "scaleX(0)",
                              transformOrigin: "bottom left",
                              transition: "transform 0.3s ease",
                              zIndex: 9,
                              borderRadius: '2px',
                            },
                            "&:hover": {
                              color: 'rgba(74, 144, 226, 1)',
                            },
                            "&:hover::after": {
                              transform: "scaleX(1)",
                            },
                          }}
                        >
                          {drop.name}
                        </Box>
                      ))}
                    </div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="nav-connect-section">
        <div
          className="nav-button"
          onClick={() => {
            navigate("/aboutus");
          }}
          style={{
            background: 'linear-gradient(135deg, rgba(74, 144, 226, 0.9), rgba(143, 148, 251, 0.9))',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '20px',
            padding: '12px 24px',
            color: 'white',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          <button className="glass-button" style={{ background: 'transparent', border: 'none', color: 'white', padding: 0 }}>About us</button>
        </div>
        <div className="header">
          <button
            className="glass-button-warm"
            onClick={() => {
              navigate("/contactus");
            }}
            style={{
              background: 'linear-gradient(135deg, rgba(251, 146, 60, 0.9), rgba(252, 211, 77, 0.9))',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '20px',
              padding: '12px 24px',
              color: 'white',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Contact us
          </button>
        </div>
      </div>
    </div>
  );
}

export default Nav;
